import { useSessionStore } from '@/shared/lib/auth';
import type { Role } from '@/entities/user';

/**
 * The app's only sanctioned way to ask "who am I?" in components.
 * Returns `null` until the session has hydrated (status === 'unknown').
 *
 * Paired with `<RoleGate>` it covers every UI gating scenario in the PRD.
 */
export function useRole(): Role | null {
  return useSessionStore((s) => s.user?.role ?? null);
}

/** True when the current role is in the allow-list. Null role = always false. */
export function useHasRole(...allowed: readonly Role[]): boolean {
  const role = useRole();
  return role !== null && allowed.includes(role);
}
